module.exports = __webpack_public_path__ + "img/Frame 5119.7fa7a4fd.jpg";